import React, { useEffect, useState } from "react";
import DTOGoals from "./DTOGoals";
import GoalsPresenter from "./GoalsPresenter";

import { useTranslation } from "react-i18next";
interface PropVal {
  passGoalDetail?: any;
}
function GoalsController({ passGoalDetail }: PropVal) {
  const { t } = useTranslation();

  const getGoalDetails = (obj: any) => {
    passGoalDetail(obj);
  };
  return (
    <div>
      <DTOGoals />
      <GoalsPresenter trans={t} handleTriggerShowDeatil={getGoalDetails} />
    </div>
  );
}

export default GoalsController;
